import { WidgetConfiguration } from "@feature/widget-configs/models/widget-configuration";

export class DiaryConfiguration {
    IncludeNotices: boolean;
}

export interface SaveDiaryConfigurationRequest {
  WidgetConfiguration: WidgetConfiguration;
  DiaryWidgetConfigurationModel: DiaryConfiguration;
}